import { useDeviceIdProvider } from '@cp/shared/deviceId';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { coreClientAuthApi } from 'src/entities/client/auth';
import { IRegistrationApiProvider } from '../lib';

export const useRegistrationApiProvider = (): IRegistrationApiProvider => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const deviceIdProvider = useDeviceIdProvider();
  return {
    async register(request) {
      const deviceId = await deviceIdProvider();
      return dispatch(coreClientAuthApi.endpoints.registration.initiate({ ...request, deviceId })).unwrap();
    },
  };
};
